import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const RunDetail = lazy(() => import('./RunDetail'))

export const OperationsAvlProposalsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--operations--avl-proposals']}>
    <Route index element={<Index />} />
    <Route path='runs/:runId' element={<RunDetail />} />
  </SubRouter>
))
